import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import Header from '../Header';
import BottomNav, { BOTTOM_NAV_HEIGHT } from '../BottomNav';
import { useAuth } from '../../AuthContext';
import tokens from '../../theme/tokens';

const Footer = () => (
  <Box component="footer" sx={{ borderTop: `1px solid ${tokens.color.border}`, bgcolor: 'background.paper', mt: 6 }}>
    <Container maxWidth="lg">
      <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center" spacing={1} sx={{ py: 3 }}>
        <Typography variant="body2" color="text.secondary">
          © {new Date().getFullYear()} Riviera FC · Riviera Boa Viagem
        </Typography>
        <Stack direction="row" spacing={2}>
          <Link component={RouterLink} to="/estatuto" variant="body2" color="text.secondary" underline="hover">Regras</Link>
          <Link component={RouterLink} to="/privacidade" variant="body2" color="text.secondary" underline="hover">Privacidade</Link>
        </Stack>
      </Stack>
    </Container>
  </Box>
);

/**
 * Estrutura padrão das páginas: cabeçalho, conteúdo centralizado e rodapé.
 * `hero` é renderizado em largura total logo abaixo do cabeçalho.
 */
const AppLayout = ({ children, hero, maxWidth = 'lg', disableGutters = false, hideHeader = false }) => {
  const { isAuthenticated, userLogado } = useAuth();
  // No celular, jogadores logados têm a barra de atalhos fixa no rodapé: reserva o espaço dela
  const comBarra = isAuthenticated && userLogado && !['Arbitro', 'Goleiro'].includes(userLogado.perfil);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', pb: comBarra ? { xs: `calc(${BOTTOM_NAV_HEIGHT}px + env(safe-area-inset-bottom))`, md: 0 } : 0 }}>
      {!hideHeader && <Header />}
      {hero}
      <Container component="main" maxWidth={maxWidth} disableGutters={disableGutters} sx={{ flexGrow: 1, py: { xs: 3, md: 4 } }}>
        {children}
      </Container>
      <Footer />
      <BottomNav />
    </Box>
  );
};

export default AppLayout;
